/* eslint-disable no-bitwise */
import type { Uuid } from "shared/types";

/**
 * Returns a cryptographically random RFC 4122 v4 UUID.
 *
 * Uses `crypto.randomUUID()` where available (secure contexts), falling back to
 * `crypto.getRandomValues()` in insecure contexts — e.g. Capacitor native
 * WebViews served over plain HTTP — where `crypto.randomUUID` is undefined.
 */
export function randomUUID(): Uuid {
  const cryptoObject = globalThis.crypto;

  if (!cryptoObject) {
    throw new Error("Web Crypto API is unavailable");
  }

  if (typeof cryptoObject.randomUUID === "function") {
    return cryptoObject.randomUUID();
  }

  const bytes = cryptoObject.getRandomValues(new Uint8Array(16));

  // RFC 4122 §4.4: pin the version (4) and variant (10xx) bits.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));

  return `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}` as Uuid;
}
